import { paths } from '@app/routes/paths';
import { env } from '@config/env';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

/** Brand mark from `design/logo.png`, served from `public/brand/logo.png`. */
export const BRAND_LOGO_SRC = '/brand/logo.jpeg';

interface AppLogoProps {
  /** When false, only the logo image is shown (collapsed sidebar). */
  showLabel?: boolean;
  /** Logo edge length in px. */
  size?: number;
}

export function AppLogo({ showLabel = true, size = 36 }: AppLogoProps) {
  return (
    <Box
      component={Link}
      to={paths.root}
      aria-label={env.VITE_APP_NAME}
      sx={{
        display: 'flex',
        width: showLabel ? 'auto' : '100%',
        alignItems: 'center',
        justifyContent: showLabel ? 'flex-start' : 'center',
        gap: showLabel ? 1.25 : 0,
        color: 'inherit',
        textDecoration: 'none',
        minWidth: 0,
      }}
    >
      <Box
        component="img"
        src={BRAND_LOGO_SRC}
        alt=""
        aria-hidden
        sx={{
          width: size,
          height: size,
          // Circular — same key shape as the rail's nav icons and the avatar.
          borderRadius: '50%',
          flexShrink: 0,
          display: 'block',
          objectFit: 'cover',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.2), 0 0 0 1px rgba(255,255,255,0.12)',
        }}
      />
      {showLabel && (
        <Typography variant="h6" component="span" noWrap sx={{ fontWeight: 700, letterSpacing: -0.2 }}>
          {env.VITE_APP_NAME}
        </Typography>
      )}
    </Box>
  );
}
